import React, { useState, useEffect, useCallback } from "react";
import Container from "react-bootstrap/Container";
import Jumbotron from "react-bootstrap/Jumbotron";
import Row from "react-bootstrap/Row";
import ProjectCard from "./ProjectCard";
import ProjectCardDummy from "./ProjectCardDummy";
import Col from "react-bootstrap/Col";
import axios from "axios";

const dummyProject = {
  name: null,
  description: null,
  svn_url: null,
  stargazers_count: null,
  languages_url: null,
  pushed_at: null,
};
const API = "https://api.github.com";
// const gitHubQuery = "/repos?sort=updated&direction=desc";
// const specficQuerry = "https://api.github.com/repos/kyleconnolly1020/";

const Project = ({ heading, username, length, specfic }) => {
  // const allReposAPI = `${API}/users/${username}/repos?sort=updated&direction=desc`;
  // const specficReposAPI = `${API}/repos/${username}`;
  // const dummyProjectsArr = new Array(length + specfic.length).fill(
  //   dummyProject
  // );

  // const [projectsArray, setProjectsArray] = useState([]);

  // const fetchRepos = useCallback(async () => {
  //   let repoList = [];
  //   try {
  //     // getting all repos
  //     const response = await axios.get(allReposAPI);
  //     // slicing to the length
  //     repoList = [...response.data.slice(0, length)];
  //     // adding specified repos
  //     try {
  //       for (let repoName of specfic) {
  //         const response = await axios.get(`${specficReposAPI}/${repoName}`);
  //         repoList.push(response.data);
  //       }
  //     } catch (error) {
  //       console.error(error.message);
  //     }
  //     // setting projectArray
  //     // TODO: remove the duplication.
  //     setProjectsArray(repoList);
  //   } catch (error) {
  //     console.error(error.message);
  //   }
  // }, [allReposAPI, length, specfic, specficReposAPI]);

  // useEffect(() => {
  //   fetchRepos();
  // }, [fetchRepos]);

  return (
    <Jumbotron fluid id="projects" className="bg-light m-0">
      <Container className="">
        <h2 className="display-4 pb-5 text-center">{heading}</h2>
        {/* <Row>
          {projectsArray.length
            ? projectsArray.map((project, index) => (
                <ProjectCard
                  key={`project-card-${index}`}
                  id={`project-card-${index}`}
                  value={project}
                />
              ))
            : dummyProjectsArr.map((project, index) => (
                <ProjectCard
                  key={`dummy-${index}`}
                  id={`dummy-${index}`}
                  value={project}
                />
              ))}
        </Row> */}
        <Row>
          <Col xs={12} md={6}>
            <img className={"projectImage"} src={require("../../editable-stuff/ComputerVisionReact.png")}/>
          </Col>
          <ProjectCardDummy
            name={"RGB ComputerVision"}
            description={"Computer Vision project using Python's CV2 library for capturing an image from client-side stream and determining the presence of RGB color within a prespecified range."}
            gh={"https://github.com/kyleconnolly1020/ComputerVisionReactDirectory"}
            link={"https://rgbcomputervision.herokuapp.com/"}
            languages={["Python", "Javascript", "React", "Flask", "CV2"]}
           />
           <hr className={"projectHr"}/>
           <Col xs={12} md={6}>
            <img className={"projectImage"} src={require("../../editable-stuff/AddaptedApp.png")}/>
          </Col>
          <ProjectCardDummy
            name={"Addapted App"}
            description={"Addapted is a collaborate storytelling and publishing app. Read, contribute, build, and enjoy from anywhere as stories take on various creative directions and twists and turns. Built with GraphQL for an incredibly modern and flexible API."}
            gh={""}
            link={"https://addapted.com/"}
            languages={["Javascript", "React", "Node.JS", "GraphQL", "Cordova", "DynamoDB", "AWS"]}
          />
          <Col xs={12} md={6}>
            <img className={"projectImage"} src={require("../../editable-stuff/plndr.png")}/>
          </Col>
          <ProjectCardDummy
            name={"Plndr"}
            description={"Plndr is a real-money online gaming app where players can enter into random giveaways and games of skill for cash prizes. Supports seamless payments with Card or PayPal, and cashout with Paypal. The app provides a web-native gaming experience and utilizes a proprietary C# API."}
            gh={""}
            link={"https://demo.plndrplay.com/"}
            languages={[ "C#", ".NET Entity Framework", "SQL Server", "Javascript", "React", "Redux", "AWS", "Phaser", "PayPal API", "Facebook Login SDK"]}
          />
          <Col xs={12} md={6}>
            <img className={"projectImage"} src={require("../../editable-stuff/float.png")}/>
          </Col>
          <ProjectCardDummy
            name={"Float File Share"}
            description={"Float is a proximity-based file sharing app that allows users to share various file formats (.pdf, .jpg, .png, .wav, social media links, etc.) and visualize others with a simple and intuitive UI.  Files are stored within Amazon S3 service. Proximity is calculated by utilizing MongoDB $near queryies."}
            gh={"https://github.com/kyleconnolly1020/float-file-share"}
            link={""}
            languages={[ "Amazon S3", "Javascript", "Google Maps API", "Node.JS", "MongoDB", "Javascript", "Auth0", "React"]}
          />
          <Col xs={12} md={6}>
            <img className={"projectImage"} src={require("../../editable-stuff/voterfied.png")}/>
          </Col>
          <ProjectCardDummy
            name={"Voterfied"}
            description={"Voterfied is a constituent engagement platform that encourages a two-way communication channel between political candidates/elected officials and their constituents. Authentication is backed by official county records. Built upon a blockchain engine, which handles authorization and allows for anonymous voting on issues."}
            gh={""}
            link={"https://voterfied.com"}
            languages={[ "React", "Javascript", "C#", "SQL Server",  "Linux Hyperledger", "Microsoft Azure"]}
          />
        </Row>
      </Container>
    </Jumbotron>
  );
};

export default Project;
